/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exactly 86,400 seconds (24 hours × 60 minutes × 60 seconds). This is a fixed, universal conversion with no rounding — every calendar day (ignoring the rare leap second) contains exactly this many seconds, which makes it a reliable base for scheduling and duration calculations.`)
};

const es_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exactamente 86,400 segundos (24 horas × 60 minutos × 60 segundos). Esta es una conversión fija y universal sin redondeo — cada día de calendario (ignorando el raro segundo intercalado) contiene exactamente este número de segundos, lo que la hace una base confiable para cálculos de programación y duración.`)
};

const de_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exakt 86,400 Sekunden (24 Stunden × 60 Minuten × 60 Sekunden). Das ist eine feste, universelle Umrechnung ohne Rundung — jeder Kalendertag (abgesehen von der seltenen Schaltsekunde) enthält genau diese Anzahl Sekunden, was ihn zu einer verlässlichen Basis für Termin- und Dauerberechnungen macht.`)
};

const nl_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exact 86.400 seconden (24 uur × 60 minuten × 60 seconden). Dit is een vaste, universele conversie zonder afronding — elke kalenderdag (de zeldzame schrikkelseconde negeren) bevat precies dit aantal seconden, wat het een betrouwbare basis voor planning en duurberekeningen maakt.`)
};

const fr_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exactement 86 400 secondes (24 heures × 60 minutes × 60 secondes). C'est une conversion fixe et universelle sans arrondi — chaque jour calendaire (en ignorant la rare seconde intercalaire) contient exactement ce nombre de secondes, ce qui la rend fiable pour la planification et les calculs de durée.`)
};

const it_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esattamente 86.400 secondi (24 ore × 60 minuti × 60 secondi). Questa è una conversione fissa e universale senza arrotondamento — ogni giorno di calendario (ignorando il raro secondo intercalare) contiene esattamente questo numero di secondi, il che la rende una base affidabile per i calcoli di programmazione e durata.`)
};

const pt_br2_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exatamente 86.400 segundos (24 horas × 60 minutos × 60 segundos). Esta é uma conversão fixa e universal sem arredondamento — cada dia do calendário (ignorando o raro segundo bissexto) contém exatamente este muitos segundos, o que o torna uma base confiável para agendamento e cálculos de duração.`)
};

const pt_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exactamente 86400 segundos (24 horas × 60 minutos × 60 segundos). Esta é uma conversão fixa, universal sem arredondamento — cada dia de calendário (ignorando o raro segundo bissexto) contém exactamente este número de segundos, que torna uma base fiável para agendamento e cálculos de duração.`)
};

const ja_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正確に86,400秒(24時間 × 60分 × 60秒)。これは丸めなしでの固定で普遍的な変換です — すべてのカレンダー日(稀なうるう秒を無視すると)この多くの秒を含むため、スケジューリングと継続時間計算の信頼できるベースです。`)
};

const zh_uc_time_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_time_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_time_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_time_faq1_a", locale)
	if (locale === "en") return en_uc_time_faq1_a(inputs)
	if (locale === "es") return es_uc_time_faq1_a(inputs)
	if (locale === "de") return de_uc_time_faq1_a(inputs)
	if (locale === "nl") return nl_uc_time_faq1_a(inputs)
	if (locale === "fr") return fr_uc_time_faq1_a(inputs)
	if (locale === "it") return it_uc_time_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_time_faq1_a(inputs)
	if (locale === "pt") return pt_uc_time_faq1_a(inputs)
	if (locale === "ja") return ja_uc_time_faq1_a(inputs)
	return zh_uc_time_faq1_a(inputs)
};